import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { WebsiteSettings } from '@/lib/firebase';

interface PageTitleProps {
  title?: string;
  description?: string;
  image?: string;
  settings?: WebsiteSettings;
}

const PageTitle = ({ title, description, image, settings }: PageTitleProps) => {
  const fullTitle = title 
    ? `${title} | ${settings?.clinic.name || 'عيادة طب الأسنان'}`
    : settings?.clinic.name || 'عيادة طب الأسنان';

  useEffect(() => {
    // Update page title
    document.title = fullTitle;
    
    // Update favicon
    if (settings?.clinic.favicon) {
      const favicon = document.getElementById('favicon') as HTMLLinkElement;
      if (favicon) {
        favicon.href = settings.clinic.favicon;
      }
    }
  }, [fullTitle, settings?.clinic.favicon]);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {image && <meta property="og:image" content={image} />}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
    </Helmet>
  );
};

export default PageTitle; 